import { render, staticRenderFns } from "./call-seller.vue?vue&type=template&id=ce240cc4&scoped=true"
import script from "./call-seller.vue?vue&type=script&lang=js"
export * from "./call-seller.vue?vue&type=script&lang=js"
import style0 from "./call-seller.vue?vue&type=style&index=0&id=ce240cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce240cc4",
  null
  
)

export default component.exports